export default __webpack_public_path__ + "static/media/dfxFileLogo.c4413c4a.png";